import React, { memo, forwardRef } from 'react';
import { IconButton as NBIconButton, IIconButtonProps } from 'native-base';

const IconButton = ({ children, ...props }: IIconButtonProps, ref: any) => {
  if (props.variant === 'link') {
    console.warn('The variant supplied to IconButton is not supported');
  }
  return (
    <NBIconButton {...props} ref={ref}>
      {children}
    </NBIconButton>
  );
};

export default memo(forwardRef(IconButton));
